import React from "react";
import SEO from "@/components/SEO";
import ServiceLocationTemplate from "@/components/ServiceLocationTemplate";

const HadfieldCdbsDentistPage = () => (
  <ServiceLocationTemplate suburbName="Hadfield" suburbSlug="hadfield" variant="cdbs-dentist" />
);

export default HadfieldCdbsDentistPage;
